/** Static catalog constants from includes/additions.php. */
export const SpeedType = [
  {
    "item_id": "DF516479-F164-87FA-7BB8-6F268BF1DCE7",
    "item_name": "Walking Speed",
    "item_type": "speed_type",
    "variable_name": "speed_walking"
  },
  {
    "item_id": "B96061AE-3369-7E7A-B6A2-C7C8FBF2A23F",
    "item_name": "Jumping Speed",
    "item_type": "speed_type",
    "variable_name": "speed_jumping"
  },
  {
    "item_id": "ED9810A9-3456-4D6B-BC5C-A1BAF5952B98",
    "item_name": "Swimming Speed",
    "item_type": "speed_type",
    "variable_name": "speed_swimming"
  },
  {
    "item_id": "EDCBE2A8-CD3D-43DC-9B92-84A634BE12AE",
    "item_name": "Climbing Speed",
    "item_type": "speed_type",
    "variable_name": "speed_climbing"
  },
  {
    "item_id": "F1D0A27A-43F1-4A4C-A5F8-ED9BD2D908D4",
    "item_name": "Flying Speed",
    "item_type": "speed_type",
    "variable_name": "speed_flying"
  },
  {
    "item_id": "ACFB413D-15A8-835B-C821-9E101B6C4F60",
    "item_name": "Burrowing Speed",
    "item_type": "speed_type",
    "variable_name": "speed_burrowing"
  },
  {
    "item_id": "3C96DE74-D9E6-4173-8671-989209A0BF97",
    "item_name": "Teleport",
    "item_type": "speed_type",
    "variable_name": "teleport"
  },
  {
    "item_id": "AE7D4EB3-DC36-BD47-978F-1DBCFE2B616A",
    "item_name": "Hovering Speed",
    "item_type": "speed_type",
    "variable_name": "speed_hovering"
  }
] as const;
export const AbilityType = [
  "passive_ability",
  "full_ability",
  "ability",
  "quick_ability",
  "lair_ability",
  "trap_ability",
  "attack_ability",
  "free_ability",
  "reaction_ability",
  "opportunity_attack_ability",
  "curse",
  "menta",
  "sanguine",
  "ability_choice"
] as const;
export const AbilityFeature = [
  "passive_ability",
  "full_ability",
  "ability",
  "quick_ability",
  "attack_ability",
  "free_ability",
  "reaction_ability",
  "opportunity_attack_ability",
  "feat",
  "spell",
  "menta",
  "curse",
  "sanguine",
  "ability_choice"
] as const;
export const UserChoiceType = [
  "essence",
  "essence_ancestry",
  "essence_background",
  "essence_feat",
  "free_ability",
  "quick_ability",
  "attack_ability",
  "ability",
  "full_ability",
  "opportunity_attack_ability",
  "reaction_ability",
  "passive_ability",
  "feat",
  "at_will_spell",
  "innate_spell_per_long_rest",
  "spell",
  "curse",
  "sanguine",
  "menta",
  "starting_equipment",
  "environment",
  "creature_type",
  "damage_type_resistance",
  "damage_type_immunity",
  "size",
  "skill_tier_2",
  "skill_tier_3"
] as const;
export const EquipmentSlot = [
  {
    "item_id": "F2D8C4B3-FA31-291C-995A-2046F84A289F",
    "item_name": "Air Around",
    "variable_name": "air_around",
    "slot_limit": 1
  },
  {
    "item_id": "0B279A55-5102-D704-8A57-0C1FF4989DFA",
    "item_name": "Armor",
    "variable_name": "armor",
    "slot_limit": 1
  },
  {
    "item_id": "F19F7A27-C0EE-DCFF-BD8F-2FA3CC03F7BB",
    "item_name": "Back",
    "variable_name": "back",
    "slot_limit": 1
  },
  {
    "item_id": "E6D02ACB-D3E9-DD8B-762A-31FE8C8D898D",
    "item_name": "Both Hands",
    "variable_name": "both_hands",
    "slot_limit": 1
  },
  {
    "item_id": "BD255B29-389B-53DC-6116-072B1A8DDD5F",
    "item_name": "Bracers",
    "variable_name": "bracers",
    "slot_limit": 1
  },
  {
    "item_id": "C48555B1-E374-9AAD-8CA0-C55D07AD6776",
    "item_name": "Breast",
    "variable_name": "breast",
    "slot_limit": 1
  },
  {
    "item_id": "6203F9AE-6699-AB57-B3C7-92864A79520C",
    "item_name": "Cloak",
    "variable_name": "cloak",
    "slot_limit": 1
  },
  {
    "item_id": "3CAA3182-3DA6-F348-CEE3-09803F221466",
    "item_name": "Clothing",
    "variable_name": "clothing",
    "slot_limit": 1
  },
  {
    "item_id": "94805078-0B0F-FD3F-77E4-AA6EE4D2E44D",
    "item_name": "Feet",
    "variable_name": "feet",
    "slot_limit": 1
  },
  {
    "item_id": "3805BDD7-3461-DDDB-F445-922A5A992987",
    "item_name": "Head",
    "variable_name": "head",
    "slot_limit": 1
  },
  {
    "item_id": "AF43D701-0755-C7E2-D26F-44E6F64AC3E2",
    "item_name": "Legs",
    "variable_name": "legs",
    "slot_limit": 1
  },
  {
    "item_id": "CEF334BF-DE96-1BEA-F72A-A4C98FBF36AD",
    "item_name": "Main Hand",
    "variable_name": "main_hand",
    "slot_limit": 1
  },
  {
    "item_id": "3CA73C13-5DC3-0DDF-CAD8-98D1CF573844",
    "item_name": "Natural Armor",
    "variable_name": "natural_armor",
    "slot_limit": 1
  },
  {
    "item_id": "5EDE9876-ED2B-3B93-C683-34428B5FDA5B",
    "item_name": "Neck",
    "variable_name": "neck",
    "slot_limit": 1
  },
  {
    "item_id": "4FF85144-67EC-9D87-AE28-15137A1A2481",
    "item_name": "Off Hand",
    "variable_name": "off_hand",
    "slot_limit": 1
  },
  {
    "item_id": "3AD8CEE8-D487-68B1-33F0-CFE04336F9B8",
    "item_name": "Ring",
    "variable_name": "ring",
    "slot_limit": 2
  },
  {
    "item_id": "16ABAE95-5D18-474D-ADFF-8C20FC2439F1",
    "item_name": "Tail",
    "variable_name": "tail",
    "slot_limit": 1
  },
  {
    "item_id": "B52059C5-526B-3F8C-E906-0D40FA23A593",
    "item_name": "Waist",
    "variable_name": "waist",
    "slot_limit": 3
  }
] as const;
export const WeaponType = [
  {
    "item_id": "1364260D-E37C-4257-AD16-5E745107811A",
    "item_name": "Melee Weapon Type",
    "item_type": "weapon_type",
    "variable_name": "melee_weapon_type"
  },
  {
    "item_id": "2BBC1E4E-5A42-41A4-8392-2C755D7A3C7C",
    "item_name": "Ranged Weapon Type",
    "item_type": "weapon_type",
    "variable_name": "ranged_weapon_type"
  }
] as const;
export const RollType = [
  {
    "item_id": "981477BF-20AC-B5B0-A9A9-A5CB4459884C",
    "item_name": "Challenge Roll Assistance Roll",
    "variable_name": "challenge_roll_assistance_roll",
    "roll_type_pl_multiplier": {
      "value": 1.5
    }
  },
  {
    "item_id": "82BBB3B6-4646-48E8-A5A2-8DC0947A91D0",
    "item_name": "Damage Roll",
    "variable_name": "damage_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "ED5B44EA-7438-9582-A388-04EFF342E460",
    "item_name": "DC Roll",
    "variable_name": "dc_roll",
    "roll_type_pl_multiplier": {
      "value": 0.4
    }
  },
  {
    "item_id": "AD80D31D-898B-66CE-0894-1335D11B1529",
    "item_name": "Contesting Roll",
    "variable_name": "contesting_roll",
    "roll_type_pl_multiplier": {
      "value": 0.4
    }
  },
  {
    "item_id": "A063F21A-02D9-BA39-9C71-09C8E8122693",
    "item_name": "Essence Roll",
    "variable_name": "essence_roll",
    "roll_type_pl_multiplier": {
      "value": 0.4
    }
  },
  {
    "item_id": "4FB7452A-F130-40C3-83E6-5E92C329D7B2",
    "item_name": "Healing Roll",
    "variable_name": "healing_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "52949AF2-7C18-4BA3-754E-4BF898A67AFD",
    "item_name": "Recharge Ability Roll",
    "variable_name": "recharge_ability_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "28B4E29C-5D8D-57CC-7634-761CEBD01190",
    "item_name": "Reduce Damage Roll",
    "variable_name": "reduce_damage_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "9909BE44-99AE-8780-BB12-BD99BA6E672E",
    "item_name": "Regeneration Roll",
    "variable_name": "regeneration_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "E26FC164-16F5-E38B-66F9-337FAEDE2A67",
    "item_name": "Skill Roll Assistance Roll",
    "variable_name": "skill_roll_assistance_roll",
    "roll_type_pl_multiplier": {
      "value": 1.5
    }
  },
  {
    "item_id": "73ECB998-6C8E-1854-FBBB-EF02AC2AC0EE",
    "item_name": "Skill Roll Retracting Roll",
    "variable_name": "skill_roll_retracting_roll",
    "roll_type_pl_multiplier": {
      "value": 1.5
    }
  },
  {
    "item_id": "5740CA49-006E-A7A0-B46B-6DDED6CD546C",
    "item_name": "Spell Melee Attack Roll",
    "variable_name": "spell_melee_attack_roll",
    "roll_type_pl_multiplier": {
      "value": 0.4
    }
  },
  {
    "item_id": "DD280A3B-6F1D-4CE9-9EFD-505A74D0C07C",
    "item_name": "Spell Ranged Attack Roll",
    "variable_name": "spell_ranged_attack_roll",
    "roll_type_pl_multiplier": {
      "value": 0.4
    }
  },
  {
    "item_id": "E5016E3A-6A12-2287-5F48-5CFAC863E967",
    "item_name": "Summon Roll",
    "variable_name": "summon_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "4634635E-4E82-DFB3-8411-27A6BFB8CF0F",
    "item_name": "Temporary Vitality Regeneration Roll",
    "variable_name": "temporary_vitality_regeneration_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "5E2689A2-0F7D-1E27-F4D5-CA09CA5C2591",
    "item_name": "Temporary Vitality Roll",
    "variable_name": "temporary_vitality_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "1EBE0C5D-4D59-F08A-B118-13286A198ED5",
    "item_name": "Weapon Attack Roll Assistance Roll",
    "variable_name": "weapon_attack_roll_assistance_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "2FE8DFB7-FE61-4862-AF71-3523262350A0",
    "item_name": "Weapon Melee Attack Roll",
    "variable_name": "weapon_melee_attack_roll",
    "roll_type_pl_multiplier": {
      "value": 0.4
    }
  },
  {
    "item_id": "3F85CA97-F9B2-A83A-FDE8-E523FD99346C",
    "item_name": "Weapon Ranged Attack Roll",
    "variable_name": "weapon_ranged_attack_roll",
    "roll_type_pl_multiplier": {
      "value": 0.4
    }
  },
  {
    "item_id": "9C752002-0C85-40D8-8DC0-D43AECBB2207",
    "item_name": "Armor Bending Roll",
    "variable_name": "armor_bending_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "5DFD335C-B12A-4B3C-9FF6-560E12D9045F",
    "item_name": "Dying Stratum Roll",
    "variable_name": "dying_stratum_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "FA17A3A2-3068-C84C-1EA5-C511F71FBD8B",
    "item_name": "Gathering Roll",
    "variable_name": "gathering_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "54DC30E0-923C-4BBF-A8CC-570B0068E8A2",
    "item_name": "Crafting Roll",
    "variable_name": "crafting_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "E1C8D281-0DC7-4883-8381-5630E23AD99D",
    "item_name": "Excavation Roll",
    "variable_name": "excavation_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "77A044B7-7041-CA96-3C63-BB718B15A364",
    "item_name": "Damage Over Time Roll",
    "variable_name": "damage_over_time_roll",
    "roll_type_pl_multiplier": {
      "value": 1.3
    }
  },
  {
    "item_id": "9878714A-27C3-D737-88B3-E8C1EE63A20F",
    "item_name": "Extra Damage Roll",
    "variable_name": "extra_damage_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "42A38751-5549-CDE7-528E-AED309A2B07D",
    "item_name": "Extra Weapon Damage Roll",
    "variable_name": "extra_weapon_damage_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "ABF66E1E-DA79-4329-31FA-70D981032C06",
    "item_name": "Skill Roll",
    "variable_name": "skill_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "F1CB1CCF-138F-0B16-266F-3AFE1AB8C73D",
    "item_name": "Extra Healing Roll",
    "variable_name": "extra_healing_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "C823C739-A9DE-AA5A-07B8-CB67F578F880",
    "item_name": "Increase Luck Roll",
    "variable_name": "increase_luck_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "DE5B6A74-0024-FFDB-C5C6-B0248D956515",
    "item_name": "Reduce Luck Roll",
    "variable_name": "reduce_luck_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "DB30C685-3830-9AEA-D8FA-D92FEA762982",
    "item_name": "Increase Mana Roll",
    "variable_name": "increase_mana_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "905613F5-A045-BC0A-3686-CD1EC15060C5",
    "item_name": "Reduce Mana Roll",
    "variable_name": "reduce_mana_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "99DC3B29-702D-08D0-346E-AA4359EA1D82",
    "item_name": "Extra Damage Taken Roll",
    "variable_name": "extra_damage_roll_taken",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "CC2CEB6B-CEFB-481F-911A-A47A427D5EB2",
    "item_name": "Lockpicking Roll",
    "variable_name": "lockpicking_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "5FC40097-3C6E-53ED-0947-486FCC6DE627",
    "item_name": "Mana Drain Roll",
    "variable_name": "mana_drain_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "F5BC82EE-DBDF-4594-F850-0C49E4292AC7",
    "item_name": "Temporary Max Vitality Roll",
    "variable_name": "temporary_max_vitality_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  },
  {
    "item_id": "67B41E3F-5BF3-33A0-B459-7B8768B71933",
    "item_name": "Training Roll",
    "variable_name": "training_roll",
    "roll_type_pl_multiplier": {
      "value": 1
    }
  }
] as const;
export const RangeType = [
  {
    "item_id": "D82855E1-4BB9-93EA-6374-B9904318BC1D",
    "item_name": "Self",
    "variable_name": "self",
    "icon_variable_name": "range_self",
    "x_distance": 0,
    "target_only": true
  },
  {
    "item_id": "7E615545-1179-6F6A-9729-0AFFCD588B31",
    "item_name": "Object Range",
    "variable_name": "object_range",
    "icon_variable_name": "range_object",
    "x_distance": 0,
    "target_only": true
  },
  {
    "item_id": "36D59FF4-6778-96ED-8664-F5D63638C77B",
    "item_name": "Reach",
    "variable_name": "reach",
    "icon_variable_name": "range_reach",
    "x_distance": "reach"
  },
  {
    "item_id": "4C761395-2532-3F23-7CBA-CA81AF5C0855",
    "item_name": "Close",
    "variable_name": "close",
    "icon_variable_name": "range_close",
    "x_distance": 30
  },
  {
    "item_id": "A95F219A-6288-6B17-6DB7-03DE4B97AE96",
    "item_name": "Near",
    "variable_name": "near",
    "icon_variable_name": "range_near",
    "x_distance": 60
  },
  {
    "item_id": "D1E8DA38-61C2-97AA-6173-4BF6157FEEE3",
    "item_name": "Far",
    "variable_name": "far",
    "icon_variable_name": "range_far",
    "x_distance": 120
  },
  {
    "item_id": "F6DAE84B-CBB3-5C0F-89EF-370DE841DFDA",
    "item_name": "Very Far",
    "variable_name": "very_far",
    "icon_variable_name": "range_very_far",
    "x_distance": 240
  },
  {
    "item_id": "BB47D2E8-FFFD-8A04-FC6C-FC02583750ED",
    "item_name": "Unlimited",
    "variable_name": "unlimited",
    "icon_variable_name": "range_unlimited",
    "x_distance": "unlimited"
  }
] as const;

export const SkillTier = [
  {
    "item_name": "Skill Tier 0",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_0",
    "skill_roll": "DIS",
    "skill_roll_dice": 0,
    "skill_roll_die": 0,
    "requires_skill_tier": "requires_skill_tier_0",
    "sp_required": 0,
    "skill_tier_level": 0,
    "pl_gp_value": 0
  },
  {
    "item_name": "Skill Tier 1",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_1",
    "skill_roll": "d4",
    "skill_roll_dice": 1,
    "skill_roll_die": 4,
    "requires_skill_tier": "requires_skill_tier_1",
    "sp_required": 1,
    "skill_tier_level": 1,
    "pl_gp_value": 1000
  },
  {
    "item_name": "Skill Tier 2",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_2",
    "skill_roll": "d5",
    "skill_roll_dice": 1,
    "skill_roll_die": 5,
    "requires_skill_tier": "requires_skill_tier_2",
    "sp_required": 4,
    "skill_tier_level": 2,
    "pl_gp_value": 4000
  },
  {
    "item_name": "Skill Tier 3",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_3",
    "skill_roll": "d6",
    "skill_roll_dice": 1,
    "skill_roll_die": 6,
    "requires_skill_tier": "requires_skill_tier_3",
    "sp_required": 7,
    "skill_tier_level": 3,
    "pl_gp_value": 7000
  },
  {
    "item_name": "Skill Tier 4",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_4",
    "skill_roll": "d7",
    "skill_roll_dice": 1,
    "skill_roll_die": 7,
    "requires_skill_tier": "requires_skill_tier_4",
    "sp_required": 10,
    "skill_tier_level": 4,
    "pl_gp_value": 10000
  },
  {
    "item_name": "Skill Tier 5",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_5",
    "skill_roll": "d8",
    "skill_roll_dice": 1,
    "skill_roll_die": 8,
    "requires_skill_tier": "requires_skill_tier_5",
    "sp_required": 13,
    "skill_tier_level": 5,
    "pl_gp_value": 13000
  },
  {
    "item_name": "Skill Tier 6",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_6",
    "skill_roll": "d9",
    "skill_roll_dice": 1,
    "skill_roll_die": 9,
    "requires_skill_tier": "requires_skill_tier_6",
    "sp_required": 16,
    "skill_tier_level": 6,
    "pl_gp_value": 16000
  },
  {
    "item_name": "Skill Tier 7",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_7",
    "skill_roll": "d10",
    "skill_roll_dice": 1,
    "skill_roll_die": 10,
    "requires_skill_tier": "requires_skill_tier_7",
    "sp_required": 19,
    "skill_tier_level": 7,
    "pl_gp_value": 19000
  },
  {
    "item_name": "Skill Tier 8",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_8",
    "skill_roll": "d11",
    "skill_roll_dice": 1,
    "skill_roll_die": 11,
    "requires_skill_tier": "requires_skill_tier_8",
    "sp_required": 22,
    "skill_tier_level": 8,
    "pl_gp_value": 22000
  },
  {
    "item_name": "Skill Tier 9",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_9",
    "skill_roll": "d12",
    "skill_roll_dice": 1,
    "skill_roll_die": 12,
    "requires_skill_tier": "requires_skill_tier_9",
    "sp_required": 25,
    "skill_tier_level": 9,
    "pl_gp_value": 25000
  },
  {
    "item_name": "Skill Tier 10",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_10",
    "skill_roll": "d13",
    "skill_roll_dice": 1,
    "skill_roll_die": 13,
    "requires_skill_tier": "requires_skill_tier_10",
    "sp_required": 28,
    "skill_tier_level": 10,
    "pl_gp_value": 28000
  },
  {
    "item_name": "Skill Tier 11",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_11",
    "skill_roll": "d14",
    "skill_roll_dice": 1,
    "skill_roll_die": 14,
    "requires_skill_tier": "requires_skill_tier_11",
    "sp_required": 40,
    "skill_tier_level": 11,
    "pl_gp_value": 40000
  },
  {
    "item_name": "Skill Tier 12",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_12",
    "skill_roll": "d15",
    "skill_roll_dice": 1,
    "skill_roll_die": 15,
    "requires_skill_tier": "requires_skill_tier_12",
    "sp_required": 50,
    "skill_tier_level": 12,
    "pl_gp_value": 50000
  },
  {
    "item_name": "Skill Tier 13",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_13",
    "skill_roll": "d16",
    "skill_roll_dice": 1,
    "skill_roll_die": 16,
    "requires_skill_tier": "requires_skill_tier_13",
    "sp_required": 60,
    "skill_tier_level": 13,
    "pl_gp_value": 60000
  },
  {
    "item_name": "Skill Tier 14",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_14",
    "skill_roll": "d17",
    "skill_roll_dice": 1,
    "skill_roll_die": 17,
    "requires_skill_tier": "requires_skill_tier_14",
    "sp_required": 80,
    "skill_tier_level": 14,
    "pl_gp_value": 80000
  },
  {
    "item_name": "Skill Tier 15",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_15",
    "skill_roll": "d18",
    "skill_roll_dice": 1,
    "skill_roll_die": 18,
    "requires_skill_tier": "requires_skill_tier_15",
    "sp_required": 100,
    "skill_tier_level": 15,
    "pl_gp_value": 100000
  },
  {
    "item_name": "Skill Tier 16",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_16",
    "skill_roll": "d19",
    "skill_roll_dice": 1,
    "skill_roll_die": 19,
    "requires_skill_tier": "requires_skill_tier_16",
    "sp_required": 120,
    "skill_tier_level": 16,
    "pl_gp_value": 120000
  },
  {
    "item_name": "Skill Tier 17",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_17",
    "skill_roll": "d20",
    "skill_roll_dice": 1,
    "skill_roll_die": 20,
    "requires_skill_tier": "requires_skill_tier_17",
    "sp_required": 140,
    "skill_tier_level": 17,
    "pl_gp_value": 140000
  },
  {
    "item_name": "Skill Tier 18",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_18",
    "skill_roll": "d21",
    "skill_roll_dice": 1,
    "skill_roll_die": 21,
    "requires_skill_tier": "requires_skill_tier_18",
    "sp_required": 160,
    "skill_tier_level": 18,
    "pl_gp_value": 160000
  },
  {
    "item_name": "Skill Tier 19",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_19",
    "skill_roll": "d22",
    "skill_roll_dice": 1,
    "skill_roll_die": 22,
    "requires_skill_tier": "requires_skill_tier_19",
    "sp_required": 180,
    "skill_tier_level": 19,
    "pl_gp_value": 180000
  },
  {
    "item_name": "Skill Tier 20",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_20",
    "skill_roll": "d23",
    "skill_roll_dice": 1,
    "skill_roll_die": 23,
    "requires_skill_tier": "requires_skill_tier_20",
    "sp_required": 200,
    "skill_tier_level": 20,
    "pl_gp_value": 200000
  },
  {
    "item_name": "Skill Tier 21",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_21",
    "skill_roll": "d24",
    "skill_roll_dice": 1,
    "skill_roll_die": 24,
    "requires_skill_tier": "requires_skill_tier_21",
    "sp_required": 220,
    "skill_tier_level": 21,
    "pl_gp_value": 220000
  },
  {
    "item_name": "Skill Tier 22",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_22",
    "skill_roll": "d25",
    "skill_roll_dice": 1,
    "skill_roll_die": 25,
    "requires_skill_tier": "requires_skill_tier_22",
    "sp_required": 240,
    "skill_tier_level": 22,
    "pl_gp_value": 240000
  },
  {
    "item_name": "Skill Tier 23",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_23",
    "skill_roll": "d26",
    "skill_roll_dice": 1,
    "skill_roll_die": 26,
    "requires_skill_tier": "requires_skill_tier_23",
    "sp_required": 260,
    "skill_tier_level": 23,
    "pl_gp_value": 260000
  },
  {
    "item_name": "Skill Tier 24",
    "item_type": "skill_tier",
    "variable_name": "skill_tier_24",
    "skill_roll": "d27",
    "skill_roll_dice": 1,
    "skill_roll_die": 27,
    "requires_skill_tier": "requires_skill_tier_24",
    "sp_required": 280,
    "skill_tier_level": 24,
    "pl_gp_value": 280000
  }
] as const;
